import { css } from '@linaria/core';
import theme from '../../../theme';

export const label = css`
  display: block;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: ${theme.colors.peoople['gris-medio-claro']};
  &[disabled] {
    color: ${theme.colors.neutral['60']};
  }
`;
